export default __webpack_public_path__ + "static/coperta-my-account-a07ab0adcbe57e358601431ecce894ca.jpg";